import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS } from "components";
import "modules/AppointmentDetails/components/DeskCommunicationLog/components/AppointmentDetails/AppointmentDetails.scss";
import { InfoColumn } from "modules/AppointmentDetails/components/DeskCommunicationLog/components/AppointmentDetails/components/InfoColumn";
import { formatDate, isDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

type AppointmentDetailsProps = {
  appointment: Appointment;
};

export const AppointmentDetails = ({ appointment }: AppointmentDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="desk-comm-section-container">
      <div className="desk-comm-section-header">{t("v8_appointment_information", "Appointment Information")}</div>

      <div className="appointment-info">
        <InfoColumn label={t("v8_wo", "WO")} value={appointment.wo_nr} icon="hashtag" />
        <InfoColumn label={`${t("v8_reg", "Reg")}.`} value={appointment.reg_number} icon="hashtag" />
        <InfoColumn label={t("v8_vin_nr", "VIN")} value={appointment.vin_nr} icon="hashtag" />

        {appointment.due_in && (isDate(appointment.due_in) || !appointment.due_in.startsWith("0001-01-01T00:00:00")) ? (
          <>
            <InfoColumn value={formatDate(appointment.due_in, DATE_FORMATS_FNS.dateMonthYear)} icon="calendar" />
            <InfoColumn value={formatDate(appointment.due_in, DATE_FORMATS_FNS.hoursMinutes)} icon="clock" />
          </>
        ) : (
          appointment.time_car_app &&
          (isDate(appointment.time_car_app) || !appointment.time_car_app.startsWith("0001-01-01T00:00:00")) && (
            <InfoColumn value={formatDate(appointment.time_car_app, DATE_FORMATS_FNS.dateMonthYear)} icon="calendar" />
          )
        )}
      </div>
    </div>
  );
};
